import type { ListViewSchema } from "./types";

export const bookingResourceConfigListViewSchema: ListViewSchema = {
  doctype: "Booking Resource Config",
  views: {
    experience: {
      columns: [
        { fieldname: "config_name", label: "Config Name", width: "grow", type: "Data" },
        { fieldname: "status", label: "Status", width: 100, type: "Status" },
        { fieldname: "slot_duration_minutes", label: "Slot Duration", width: 120, type: "Int" },
        { fieldname: "max_concurrent_bookings", label: "Max Concurrent", width: 130, type: "Int" },
        { fieldname: "advance_booking_days", label: "Advance Days", width: 120, type: "Int" },
      ],
      defaultSort: { fieldname: "creation", direction: "desc" },
      additionalFields: [
        "min_booking_slots",
        "max_booking_slots",
        "company",
      ],
    },
    system: {
      columns: [],
    },
  },
};
